import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import qs from 'qs';
import React from 'react';
import { connect } from 'react-redux';
import { initialize, submit } from 'redux-form';
import MksRequestsTableView from '../../components/MKS/MksRequestsTableView.jsx';
import MksRequestForm from '../../components/forms/MKS/MksRequestForm.jsx';
import MksRequestDetailsView from '../../components/MKS/MksRequestDetailsView.jsx';
import OperationalView from '../../components/OperationalView/OperationalView.jsx';
import PresentationalViewHeader from '../../components/PresentationalView/PresentationalViewHeader.jsx';
import MDButton from '../../components/MDButton/MDButton.jsx';
import * as MksActions from '../../redux/actions/mks.actions';
import * as UtilsActions from '../../redux/actions/utils.actions';
import * as ModalActions from '../../redux/actions/modal.actions';
import { CommentOutlined } from '@material-ui/icons';
import { GREEN, MKS_REQUEST_STATUSES, MKS_REQUEST_TYPES, MKS_REQUEST_STATUSES_PARAMETERS } from '../../_config/consts';
import { elaborateMksRequestDataInPayload } from '../../_config/utils.js';
import TranslatableOption from '../../components/forms/Fields/TranslatableOption.jsx';

let filterTimeout;

@connect(state => ({ 
  mks: state.mks, 
  routing: state.router, 
  language: state.settings.language, 
  viewLoading: state.utils.viewLoading, 
  themeName: state.settings.items.theme.data.themeName,
  routing: state.router,
}))
class MksRequests extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isOperationalMode: false,
      isDetailsMode: false,
      imagePreviews: [],
      shouldSendAfterSubmit: false,
    };
  }

  async componentWillMount() {
    await this.onFetchRequests();
    // Load keys and cylinders for the form
    await this.onFetchKeysAndCylinders();
    const { routing } = this.props;
    const parsed = qs.parse(routing.location.search, { ignoreQueryPrefix: true });
    const cylinderId = parsed.cylinderId;
    const keyId = parsed.keyId;
    if (keyId) {
      this.onHandleKeyExternalRequest(keyId);
    }
    if (cylinderId) {
      this.onHandleCylinderExternalRequest(cylinderId);
    }
  }

  async onFetchKeysAndCylinders() {
    const { dispatch } = this.props;
    try {
      await dispatch(MksActions.fetchKeys(0, 1000));
      await dispatch(MksActions.fetchCylinders(0, 1000));
    } catch (error) {
      console.error('Error fetching keys/cylinders:', error);
    }
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(MksActions.setSelectedMksRequest({}));
  }

  async onHandleKeyExternalRequest(keyId) {
    const { dispatch } = this.props;
    dispatch(UtilsActions.setSpinnerVisibile(true));
    try {
      const key = await dispatch(MksActions.fetchKeyById(keyId));
      const keysDuplicatesData = [{
        key: {
          value: key,
          label: `${key.designation || key.externalId || key.id} - ${key.keyFunction || ''}`,
        },
        quantity: 1,
      }];
      dispatch(initialize('MksRequestForm', {
        requestType: MKS_REQUEST_TYPES.KEY_DUPLICATION,
        notes: '',
        keysDuplicates: keysDuplicatesData,
      }));
      dispatch(UtilsActions.setSpinnerVisibile(false));
      this.setState({ isOperationalMode: true, isDetailsMode: false });
    } catch (error) {
      console.error('Error fetching key:', error);
      dispatch(UtilsActions.setSpinnerVisibile(false));
    }
  }

  
  async onHandleCylinderExternalRequest(cylinderId) {
    const { dispatch } = this.props;
    dispatch(UtilsActions.setSpinnerVisibile(true));
    try {
      const cylinder = await dispatch(MksActions.fetchCylinderById(cylinderId));
      const cylindersDuplicatesData = [{
        cylinder: {
          value: cylinder,
          label: `${cylinder.doorName || cylinder.marking || cylinder.externalId || cylinder.id} - ${cylinder.type || ''}`,
        },
        quantity: 1,
      }];
      dispatch(initialize('MksRequestForm', {
        requestType: MKS_REQUEST_TYPES.CYLINDER_DUPLICATION,
        notes: '',
        cylindersDuplicates: cylindersDuplicatesData,
      }));
      dispatch(UtilsActions.setSpinnerVisibile(false));
      this.setState({ isOperationalMode: true, isDetailsMode: false });
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
    }
  }

  async onFetchRequests(page = 0) {
    const { dispatch } = this.props;
    dispatch(UtilsActions.setViewLoading(true));
    try {
      await dispatch(MksActions.fetchMKSRequests(page));
    } catch (error) {
      console.error('Error fetching requests:', error);
    } finally {
      dispatch(UtilsActions.setViewLoading(false));
    }
  }

  onFetchRequestsOnPage(page) {
    this.onFetchRequests(page);
  }

  async onSelectRequest(request) {
    const { dispatch } = this.props;
    if (request.status === MKS_REQUEST_STATUSES.DRAFT) {
      dispatch(MksActions.setSelectedMksRequest(request));
      const requestData = elaborateMksRequestDataInPayload(request);
      dispatch(initialize('MksRequestForm', { ...request, ...requestData }));
      this.setState({ isOperationalMode: true, isDetailsMode: false });
    } else {
      dispatch(UtilsActions.setSpinnerVisibile(true));
      try {
        const requestDetail = await dispatch(MksActions.fetchMKSRequestById(request.id));
        dispatch(MksActions.setSelectedMksRequest(requestDetail));
        this.setState({ isDetailsMode: true, isOperationalMode: false });
      } catch (error) {
        console.error('Error fetching request details:', error);
        dispatch(ModalActions.showModal({
          modalType: 'ERROR_ALERT',
          modalProps: {
            message: (<h6 className="snack-title"><Entity entity="errorFetchingRequestDetails" /></h6>),
          },
        }));
      } finally {
        dispatch(UtilsActions.setSpinnerVisibile(false));
      }
    }
  }

  onNewRequestButtonClicked() {
    const { dispatch } = this.props;
    dispatch(MksActions.setSelectedMksRequest({}));
    dispatch(initialize('MksRequestForm', {
      requestType: null,
      notes: '',
    }));
    this.setState({ isOperationalMode: true, isDetailsMode: false });
  }

  onCloseOperationalSection() {
    const { dispatch } = this.props;
    this.setState({ isOperationalMode: false, isDetailsMode: false });
    dispatch(MksActions.setSelectedMksRequest({}));
  }

  async onSubmitRequest(formData) {
    const { dispatch, mks: { mksRequests: { selectedRequest } } } = this.props;
    const { shouldSendAfterSubmit } = this.state;
    
    try {
      dispatch(UtilsActions.setSpinnerVisibile(true));

      let requestResult;
      
      // Create or update the request
      if (selectedRequest && selectedRequest.id) {
        requestResult = await dispatch(MksActions.updateMKSRequest(selectedRequest.id, formData));
      } else {
        requestResult = await dispatch(MksActions.createMKSRequest(formData));
      }
      // If shouldSendAfterSubmit is true, change status to SENT
      if (shouldSendAfterSubmit && requestResult) {
        await dispatch(MksActions.updateMKSRequest(requestResult.id, { ...requestResult, status: MKS_REQUEST_STATUSES.SENT }));
      }
      dispatch(UtilsActions.setSpinnerVisibile(false));
      this.setState({ isOperationalMode: false, isDetailsMode: false, shouldSendAfterSubmit: false });
      
      // Refresh the list
      await this.onFetchRequests();
      
      const successMessage = shouldSendAfterSubmit 
        ? 'mksRequestSentSuccessfully' 
        : (selectedRequest && selectedRequest.id ? 'mksRequestUpdatedSuccessfully' : 'mksRequestCreatedSuccessfully');
      
      dispatch(ModalActions.showModal({
        modalType: 'SUCCESS_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity={successMessage} /></h6>),
        },
      }));
    } catch (error) {
      console.error('Error creating/sending request:', error);
      dispatch(UtilsActions.setSpinnerVisibile(false));
      this.setState({ shouldSendAfterSubmit: false });
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="mksRequestCreationError" /></h6>),
        },
      }));
    }
  }

  async onSendRequest(request) {
    const { dispatch } = this.props;
    try {
      dispatch(UtilsActions.setSpinnerVisibile(true));
      
      await dispatch(MksActions.updateMKSRequest(request.id, { ...request, status: MKS_REQUEST_STATUSES.SENT }));
      
      dispatch(UtilsActions.setSpinnerVisibile(false));
      
      // Refresh the list
      await this.onFetchRequests();
      
      dispatch(ModalActions.showModal({
        modalType: 'SUCCESS_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="mksRequestSentSuccessfully" /></h6>),
        },
      }));
    } catch (error) {
      console.error('Error sending request:', error);
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="mksRequestSendError" /></h6>),
        },
      }));
    }
  }


  onFileRejected() {
    const { dispatch } = this.props;
    dispatch(ModalActions.showModal({
      modalType: 'ERROR_ALERT',
      modalProps: {
        message: (<h6 className="snack-title"><Entity entity="fileRejected" /></h6>),
      },
    }));
  }

  onSearchReset() {
    const { dispatch } = this.props;
    dispatch(MksActions.resetMksFilter());
    this.onFetchRequests();
  }

  onSelectRequestType(value) {
    const { dispatch } = this.props;
    if (value === 'ALL') {
      dispatch(MksActions.setMksFilter('requestType', undefined));
    } else {
      dispatch(MksActions.setMksFilter('requestType', value));
    }
    this.onFetchRequests();
  }

  onSelectStatus(value) {
    const { dispatch } = this.props;
    if (value === 'ALL') {
      dispatch(MksActions.setMksFilter('status', undefined));
    } else {
      dispatch(MksActions.setMksFilter('status', value));
    }
    this.onFetchRequests();
  }

  render() {
    const { 
      mks: { mksRequests: { data: requestsData, selectedRequest } }, 
      themeName, 
      viewLoading,
      dispatch,
    } = this.props;
    const { isOperationalMode, isDetailsMode } = this.state;
    const pagination = requestsData && requestsData.content ? _.omit(requestsData, 'content') : {};
    const numberOfRequests = pagination.totalElements || 0;

    const requestTypeOptions = [
      { value: 'ALL', label: 'all' },
      { value: MKS_REQUEST_TYPES.KEY_DUPLICATION, label: 'mksRequestTypeKeyDuplication' },
      { value: MKS_REQUEST_TYPES.CYLINDER_DUPLICATION, label: 'mksRequestTypeCylinderDuplication' },
      { value: MKS_REQUEST_TYPES.KEY_EXTENSION, label: 'mksRequestTypeKeyExtension' },
      { value: MKS_REQUEST_TYPES.CYLINDER_EXTENSION, label: 'mksRequestTypeCylinderExtension' },
    ];

    const statusOptions = [
      { value: 'ALL', label: 'all' },
      ..._.map(MKS_REQUEST_STATUSES, (status) => ({
      value: status,
      label: MKS_REQUEST_STATUSES_PARAMETERS[status]?.string || status,
    })),
    ];

    return (
      <div>
        <PresentationalViewHeader
          themeName={themeName}
          onNewEntity={() => this.onNewRequestButtonClicked()}
          onSearchSubmit={() => this.onFetchRequests()}
          onSearchReset={() => this.onSearchReset()}
          searchGuestContainerStyle={{ width: 280 }}
          newEntityTitle="createNewMksRequest"
          searchPlaceholderEntityName="searchRequests"
          isLoading={viewLoading}
          numberOfElements={numberOfRequests}
          selectableFieldName="requestType"
          onSelectOption={option => this.onSelectRequestType(option)}
          selectableOptions={_.map(requestTypeOptions, option =>
            <Entity
              key={option.value}
              componentClass={TranslatableOption}
              value={option.value}
              componentAttribute="text"
              entity={option.label}
            />
          )}
          selectableFieldName2="status"
          onSelectOption2={option => this.onSelectStatus(option)}
          selectableOptions2={_.map(statusOptions, option =>
            <Entity
              key={option.value}
              componentClass={TranslatableOption}
              value={option.value}
              componentAttribute="text"
              entity={option.label}
            />
          )}
          entitiesNumberSection={
            <div style={{ marginRight: 20, marginTop: 13, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <CommentOutlined style={{ fontSize: 22 }} />
              <h4 style={{ marginTop: 5 }}>{numberOfRequests}</h4>
            </div>
          }
        />
        <MksRequestsTableView
          onSelectRequest={request => this.onSelectRequest(request)}
          onRefreshRequests={() => this.onFetchRequests()}
          onFetchRequestsOnPage={page => this.onFetchRequestsOnPage(page)}
          onSendRequest={request => this.onSendRequest(request)}
        />
        <OperationalView
          themeName={themeName}
          isVisible={isOperationalMode}
          onClose={() => this.onCloseOperationalSection()}
          title={<Entity entity={selectedRequest && selectedRequest.id ? "editMksRequest" : "createMksRequest"} />}
        >
          <div style={{ padding: 5, paddingTop: 0, paddingBottom: 100 }}>
            <MksRequestForm
              onFileRejected={() => this.onFileRejected()}
              onSubmit={formData => this.onSubmitRequest(formData)}
            />
            <div style={{ 
              position: 'absolute', 
              left: 0, 
              right: 0, 
              bottom: 0, 
              width: '100%', 
              display: 'flex', 
              flexDirection: 'row',
            }}>
              <MDButton
                title={selectedRequest && selectedRequest.id ? <Entity entity="updateDraft" /> : <Entity entity="saveAsDraft" />}
                containerStyle={{ flex: 1, margin: 0 }}
                style={{ height: 45, borderRadius: 0 }}
                backgroundColor="gray"
                onClick={() => {
                  this.setState({ shouldSendAfterSubmit: false });
                  dispatch(submit('MksRequestForm'));
                }}
              />
              <MDButton
                title={<Entity entity="sendNow" />}
                containerStyle={{ flex: 1, margin: 0 }}
                style={{ height: 45, borderRadius: 0 }}
                backgroundColor={GREEN}
                onClick={() => {
                  this.setState({ shouldSendAfterSubmit: true });
                  dispatch(submit('MksRequestForm'));
                }}
              />
            </div>
          </div>
        </OperationalView>
        <OperationalView
          themeName={themeName}
          isVisible={isDetailsMode}
          onClose={() => this.onCloseOperationalSection()}
          title={<Entity entity="mksRequestDetails" />}
        >
          <div style={{ padding: 5, paddingTop: 0, paddingBottom: 20 }}>
            <MksRequestDetailsView requestData={selectedRequest} />
          </div>
        </OperationalView>
      </div>
    );
  }
} 

export default MksRequests;

